function isValidGrading(grading: string) {
  return /[sml\dx]/i.test(grading)
}

export function sortGradeList<T extends string | object>(values: T[], valueKey?: keyof T): T[] {
  const getGradeValue = (item: T): string => {
    if (typeof item === 'string') {
      return item
    }
    else if (valueKey) {
      const value = item[valueKey]
      return typeof value === 'string' ? value : String(value)
    }
    return ''
  }

  if (!values.every(item => isValidGrading(getGradeValue(item))))
    return values

  function calculateGradePriority(grade: string): number {
    const lowerGrade = grade.toLowerCase()

    // Base priority by category
    let basePriority = 0
    if (lowerGrade.includes('s'))
      basePriority = -10000
    else if (lowerGrade.includes('m'))
      basePriority = 0
    else if (lowerGrade.includes('l'))
      basePriority = 10000

    let sizeModifier = 0

    // Numeric prefix pattern (2xs, 3xl)
    const numericPrefixMatch = lowerGrade.match(/^(\d+)x/)
    if (numericPrefixMatch) {
      const num = Number.parseInt(numericPrefixMatch[1])
      if (lowerGrade.includes('s')) {
        sizeModifier = -num * 100 - 1 // -1 ensures 2xs comes after xxs
      }
      else if (lowerGrade.includes('l')) {
        sizeModifier = num * 100 + 1 // +1 ensures 2xl comes after xxl
      }
    }
    // Leading X pattern (xs, xxl)
    else {
      const leadingXMatch = lowerGrade.match(/^x+/)
      const xCount = leadingXMatch ? leadingXMatch[0].length : 0
      if (xCount > 0) {
        sizeModifier = xCount * 100 * (lowerGrade.includes('s') ? -1 : 1)
      }
    }

    return basePriority + sizeModifier
  }

  return [...values].sort((first, second) => {
    const firstGrade = getGradeValue(first)
    const secondGrade = getGradeValue(second)

    const numFirstGrade = Number(firstGrade)
    const numSecondGrade = Number(secondGrade)

    if (!Number.isNaN(numFirstGrade) && !Number.isNaN(numSecondGrade))
      return numFirstGrade - numSecondGrade

    if (!Number.isNaN(numFirstGrade) && Number.isNaN(numSecondGrade))
      return -1

    if (Number.isNaN(numFirstGrade) && !Number.isNaN(numSecondGrade))
      return 1

    return calculateGradePriority(firstGrade) - calculateGradePriority(secondGrade)
  })
}
